<template lang="pug">
  include ./../../../mixins
  +b.popup-wrapper
    +b.I.icon.icon-bootsrap-x.btn-close-popup(
      @click='$emit("close")'
    )
    +b.popup-title(v-if='title') {{ title }}
    +b.P.popup-description.item-description(v-if='information') {{ information }}
    +b.form-button--info-popup
      +b.BUTTON.btn-red--popup(
        v-if="!btnLink"
        type="button" @click='$emit("close")'
      ) {{ btnTitleVal }}
      +b.A.btn-red--popup(
        v-else
        :href="btnLink"
      ) {{ btnTitleVal }}
</template>

<script>

export default {
  props: {
    info: {},
    title: {},
    information: {},
    btnTitle: {},
    btnLink: {},
  },
  data() {
    return {
      btnTitleVal: this._('Добре'),
    }
  },
  mounted() {
    if (this.info) {
      console.log(this.info)
      if (this.info.btntitle) {
        this.btnTitleVal = this.info.btntitle
      }
      if (this.info.title) {
        this.title = this.info.title
      }
      if (this.info.btnlink) {
        this.btnLink = this.info.btnlink
      }
    } else if (this.btnTitle) {
      this.btnTitleVal = this.btnTitle
    }
  },
}

</script>
